angular.module('agreements')
    .controller('AgreementOfferDiffController', function ($http, $scope, $rootScope, $uibModalInstance, data, AgreementBgt, Agreement, AgreementService) {

        this.AgreementService = AgreementService

        this.$onInit = () => {
            this.load()
        }

        this.cancel = () => $uibModalInstance.dismiss()
        this.select = selected => $uibModalInstance.close(selected)
        this.reset = () => {
        }

        this.load = () => {
            this.items = {}
            this.offers = data
            data.forEach(item => {
                AgreementBgt.query({agreementId: item.id}).$promise.then(result => {
                    this.items[item.id] = result

                    if(Object.keys(this.items).length === data.length){
                        this.processAll()
                    }
                })
            })
        }

        this.getAmount = (offerId, groupId) => {
            let items = this.items[offerId].filter(item => item.group.id === groupId)
            if(items.length > 0){
                return items.reduce((sum, item) => sum + item.amount, 0);
            }
            return null;
        }

        this.isCheapest = (offer) => {
            let cheaper = this.offers.filter(o => o.id !== offer.id).filter(o => o.totalNet != null && o.totalNet <= offer.totalNet)
            return cheaper.length === 0;
        }

        this.isMostExpensive = (offer) => {
            let records = this.offers.filter(o => o.id !== offer.id).filter(o => o.totalNet != null && o.totalNet >= offer.totalNet)
            return records.length === 0;
        }

        this.processAll = () => {
            this.allGroups = [];
            Object.keys(this.items).forEach(key => {
                let item = this.items[key];
                item.map(item => item.group).forEach(g => {
                    this.allGroups.push(g);
                })
            });

            const uniqueItems = Object.values(
                this.allGroups.reduce((acc, item) => {
                    acc[item.id] ??= item;
                    return acc;
                }, {})
            );

            const grouped = uniqueItems.reduce((acc, item) => {
                const pid = item.parent.id;
                acc[pid] ??= { parent: item.parent, children: [] };
                acc[pid].children.push(item);
                return acc;
            }, {});

            this.groupedItems = grouped;
        }
    })
